var map = {
	"./flag_chi.png": 90065,
	"./flag_chi.svg": 88415,
	"./flag_en.png": 30362,
	"./flag_en.svg": 34918,
	"./flag_eng.png": 20815,
	"./flag_eng.svg": 40613,
	"./flag_fil.png": 76310,
	"./flag_mao.gif": 92117,
	"./flag_mao.png": 17782,
	"./flag_mao.svg": 60988,
	"./flag_nor.png": 14230,
	"./flag_tr.png": 72157,
	"./flag_tr.svg": 60993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73134;